import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const fieldCls = "rounded-none bg-transparent border-white/20 h-12 focus-visible:ring-primary";

export const Field = ({ label, children }) => (
  <div className="space-y-2">
    <Label className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-400">{label}</Label>
    {children}
  </div>
);

export const TextField = ({ label, value, onChange, testId, ...props }) => (
  <Field label={label}>
    <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={fieldCls} data-testid={testId} {...props} />
  </Field>
);

export const AreaField = ({ label, value, onChange, testId, rows = 6, hint }) => (
  <Field label={label}>
    <Textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={rows} className="rounded-none bg-transparent border-white/20 focus-visible:ring-primary" data-testid={testId} />
    {hint && <p className="text-xs text-zinc-500">{hint}</p>}
  </Field>
);

// content: paragraphs separated by blank lines; embeds: one URL per line
export const contentToText = (arr = []) => arr.join("\n\n");
export const textToContent = (t = "") => t.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
export const embedsToText = (arr = []) => arr.join("\n");

const ytId = (url) => {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
  return m ? m[1] : null;
};

const decode = (s) => s.replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#0?39;/g, "'");
const mixcloudWidget = (path) => {
  const p = path.replace(/^\/+|\/+$/g, "");
  return p.includes("/") ? `https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&feed=${encodeURIComponent(`/${p}/`)}` : null;
};

// page URL or player code -> URL that can live in an <iframe> (the server applies the same rules)
export const toEmbed = (raw) => {
  const s = decode(raw.trim());
  const id = ytId(s);
  if (id && /youtu/.test(s)) return `https://www.youtube.com/embed/${id}`;
  let u;
  try { u = new URL(s); } catch { return null; }
  if (/mixcloud\.com$/.test(u.hostname)) {
    if (u.hostname.startsWith("player-widget") || u.pathname.includes("/widget/")) {
      return mixcloudWidget((u.searchParams.get("feed") || "").replace(/^https?:\/\/(www\.)?mixcloud\.com/, ""));
    }
    return mixcloudWidget(decodeURIComponent(u.pathname));
  }
  if (/^(www\.|m\.)?soundcloud\.com$/.test(u.hostname)) return `https://w.soundcloud.com/player/?url=${encodeURIComponent(s.split("?")[0])}`;
  return s;
};
// pasted <iframe … src="…"> code (even over several lines) is reduced to its src
export const textToEmbeds = (t = "") => [...new Set(
  t.replace(/<iframe[\s\S]*?\ssrc=["']([^"']+)["'][\s\S]*?(<\/iframe>|>)/gi, "\n$1\n")
    .split("\n").map((u) => u.trim()).filter((u) => /^https?:\/\//.test(u)).map(toEmbed).filter(Boolean),
)];
export const parseYoutubeId = (v = "") => ytId(v) || (/^[\w-]{11}$/.test(v.trim()) ? v.trim() : null);
